import { addMonths, differenceInMonths, format } from 'date-fns';
import { parseIsoDate } from 'ns_libs/formatter';
import { SaleFrequency } from 'views/ProFormaTable/types';

export const getSalesPeriodLabel = (
    period: number,
    frequency: SaleFrequency,
    salesStart: string | null | undefined,
    constructionStart: string | null | undefined,
    periodStartDate?: string | null,
): string => {
    const prefix = frequency === 'monthly' ? 'MO' : 'QTR';
    const monthStep = frequency === 'monthly' ? 1 : 3;

    const constructionStartDate = constructionStart ? parseIsoDate(constructionStart) : null;
    const salesStartDate = salesStart ? parseIsoDate(salesStart) : null;
    if (!constructionStartDate || !salesStartDate) {
        const periodDate = periodStartDate ? parseIsoDate(periodStartDate) : null;
        if (periodDate) {
            return `${prefix} ${period} - ${format(periodDate, 'MMM yyyy')}`;
        }
        return `${prefix} ${period}`;
    }

    const firstOption = addMonths(
        new Date(constructionStartDate.getFullYear(), constructionStartDate.getMonth(), 1),
        monthStep,
    );
    const startIndex = Math.floor(differenceInMonths(salesStartDate, firstOption) / monthStep);

    const absoluteIndex = startIndex >= 0 ? startIndex + period : period;
    const periodDate = periodStartDate
        ? parseIsoDate(periodStartDate)
        : addMonths(firstOption, (absoluteIndex - 1) * monthStep);

    if (!periodDate) {
        return `${prefix} ${absoluteIndex}`;
    }
    return `${prefix} ${absoluteIndex} - ${format(periodDate, 'MMM yyyy')}`;
};
